import { parse, format, isValid } from 'date-fns'

export default {
  formattedShowFrom () {
    const parsed = parse(this.formattedShowFrom, 'dd/MM/yyyy HH:mm', new Date())
    if (isValid(parsed)) {
      this.notification.showFrom = format(parsed, 'yyyy-MM-dd HH:mm:ssXX')
    }
  },

  formattedShowUntil () {
    const parsed = parse(this.formattedShowUntil, 'dd/MM/yyyy HH:mm', new Date())
    if (isValid(parsed)) {
      this.notification.showUntil = format(parsed, 'yyyy-MM-dd HH:mm:ssXX')
    }
  },
}
